export const VACANCY_GOV = {
    REGULATION_LAW: 'regulationLaw',
    REGULATION_BOARD: 'regulationBoard',
    RESPONSIBLE_LAW: 'responsibleLaw',
    ACCOUNTABLE_LAW: 'accountableLaw',
    RESPONSIBLE_BOARD: 'responsibleBoard',
    ACCOUNTABLE_BOARD: 'accountableBoard',
    USER_DEPARTMENT: 'userDepartment'
}
